function getBrowserCoordinates(geolocation) {
  if (!geolocation || typeof geolocation.getCurrentPosition !== 'function') {
    return Promise.reject(new Error('浏览器不支持定位'));
  }
  return new Promise((resolve, reject) => {
    geolocation.getCurrentPosition(
      position => resolve({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      }),
      error => reject(error || new Error('无法获取当前位置')),
      {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 600000
      }
    );
  });
}

function pickCityName(data) {
  const location = data || {};
  const city = String(location.city || '').trim();
  const locality = String(location.locality || '').trim();
  if (city && locality && city !== locality) {
    return `${city} · ${locality}`;
  }
  return locality
    || city
    || String(location.principalSubdivision || '').trim()
    || String(location.countryName || '').trim()
    || '当前位置';
}

function reverseGeocode(http, latitude, longitude) {
  return http.get('https://api.bigdatacloud.net/data/reverse-geocode-client', {
    timeout: 6000,
    params: {
      latitude,
      longitude,
      localityLanguage: 'zh'
    }
  }).then(response => pickCityName(response.data));
}

module.exports = {
  getBrowserCoordinates,
  pickCityName,
  reverseGeocode
};
